import React from "react";
import Icon from "../../../components/Icon";
import Box from "../../../components/Box";
import Label from "../../../components/Label";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ErrorMessage from "../../../components/ErrorMessage";
const DisableMemberModal = ({
  show,
  handleDelete,
  setshow,
  text,
  isProfileModal = false,
	setComment,
	comment,
  successText = 'Yes',
  isShowReason
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState("");

  const handleTextareaChange = (e) => {
    const value = e.target.value;
    const alphabetRegex = /^[A-Za-z\s]*$/;

    if (!alphabetRegex.test(value)) {
      setError("Only alphabets are allowed");
    } 
    if(value.trim() === "") {
      setError("Reason cannot be empty");
    } else {
      setError("")
    }

    setComment(value);
  };
  const handleOnClick = () => {
    if (comment.length === 0 || error) return;

    if(successText === 'Yes')
     setshow(!show);
    handleDelete();
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div></div>
        <div onClick={() => setshow(null, false)}>
          <Icon
            // style={{zIndex: 2000}}
            iconName="blackCross"
          />
        </div>
      </div>
      <div className="congrats-screen">
        <img src="https://ik.imagekit.io/rzlzf40okya/elixir/diseble.svg" alt="disable"/>
        <Box mt="15px">
          <h4>{text}</h4>
          {isProfileModal && (
            <div>
							<Label>{t('Mention Reason')}<span style={{ color: "#FE1717" }}>*</span></Label>
              <textarea
                className="input-boxx"
                style={{ padding: "10px" }}
                maxLength={150}
								onChange={handleTextareaChange}
              ></textarea>
              {error && (
                <ErrorMessage>{t(error)}</ErrorMessage>
              )}
              {isShowReason && (
                <p className="text-start mt-3" style={{color: "#FE4646", fontSize: "14px", fontWeight: "500"}}>
                 {t("Note")}: {t("The reason for deactivating a member's account will be shared with the member.")}
                </p>
              )}
            </div>
          )}
        </Box>
        {/* <Label color="#7E7E7E">{text}</Label> */}

        <div className="d-flex justify-content-around mt-3">
          <button className="prev-bt" onClick={() => setshow(!show)}>
            {t("Cancel")}
          </button>
          <button 
          className={comment.trim().length > 0 && !error ? "fill-bt" : "gray-bt"} 
          disabled={comment.trim().length===0 || !!error} 
          onClick={() => handleOnClick()}>
            {t(successText)}
          </button>
        </div>
      </div>
    </>
  );
};

export default DisableMemberModal;
